module.exports = __webpack_public_path__ + "41e77b189e1b481c76c8968e1ff3c61b.png";